import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import { AuthGuardSuperAdmin } from 'src/auth/guard/auth-guard';
import { GiveawayLiveDrawSlotMachine, GiveawayResultSlotMachine } from 'src/sections/giveaway-menu/view';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
// PRODUCT
const ProductDetailsPage = lazy(() => import('src/pages/dashboard/product/details'));
// ORDER
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
// Aboutt PAGE
const AbouttPage = lazy(() => import('src/pages/dashboard/aboutt'));
// AdsManagementPage
const AdsManagementPage = lazy(() => import('src/pages/dashboard/adsManagement'));
// OrganizersGiveawayPage
const OrganizersGiveawayPage = lazy(() => import('src/pages/dashboard/organizersGiveaway'));
const OrganizersGiveawayDetailPage = lazy(() =>
  import('src/pages/dashboard/organizersGiveawayDetail')
);
// termsAndConditions PAGE
const TermsAndConditionsPage = lazy(() => import('src/pages/dashboard/termsAndConditions'));
// ContactUsPage
const ContactUsPage = lazy(() => import('src/pages/dashboard/contactUs'));
// FAQSSPage
const FAQSSPage = lazy(() => import('src/pages/dashboard/faqss'));
// ClientsPage
const ClientsPage = lazy(() => import('src/pages/dashboard/clients'));
// ClientsProfilePage
const ClientsProfilePage = lazy(() => import('src/pages/dashboard/clientsProfile'));
// OrganizersPage
const OrganizersPage = lazy(() => import('src/pages/dashboard/organizers'));
// OrganizersProfilePage
const OrganizersProfilePage = lazy(() => import('src/pages/dashboard/organizersProfile'));
// UserssPage
const UserssPage = lazy(() => import('src/pages/dashboard/userss'));
// UserssProfilePage
const UserssProfilePage = lazy(() => import('src/pages/dashboard/userssProfile'));
const GiveawayPage = lazy(() => import('src/pages/dashboard/giveaway'));
// UserssProfilePage
// PrivacyPolicysPage
const PrivacyPolicysPage = lazy(() => import('src/pages/dashboard/privacyPolicy'));
const CreateNewGiveawayPage = lazy(() => import('src/pages/dashboard/createNewGiveaway'));
const EditingGiveawayPage = lazy(() => import('src/pages/dashboard/editGiveaway'));

const CategoryPage = lazy(() => import('src/pages/dashboard/category'));

const AdsManagementDetailPage = lazy(() => import('src/pages/dashboard/ads-mangement-detail-page'));

// ----------------------------------------------------------------------

export const superadmindashboardRoutes = [
  {
    path: 'super-admin',
    element: (
      <AuthGuardSuperAdmin>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuardSuperAdmin>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'giveaway',
        children: [
          { element: <GiveawayPage />, index: true },
          { path: 'new', element: <CreateNewGiveawayPage /> },
          { path: ':id/edit', element: <EditingGiveawayPage /> },
          { path: 'detail/:id', element: <ProductDetailsPage /> },
          { path: 'live-draw/:id', element: <GiveawayLiveDrawSlotMachine /> },
          { path: "result/:id", element: <GiveawayResultSlotMachine /> },
        ]
      },
      {
        path: 'admin',
        children: [
          { path: 'account', element: <UserAccountPage /> },
        ],
      },
      {
        path: 'product',
        children: [
          { path: ':id', element: <ProductDetailsPage /> },
        ],
      },
      { path: 'about', element: <AbouttPage /> },
      { path: 'ads-management', element: <AdsManagementPage /> },
      // { path: 'ads-management/detail/:id', element: <AdsManagementDetailPage /> },
      { path: 'organizers-giveaway', element: <OrganizersGiveawayPage /> },
      { path: 'organizers-giveaway-detail', element: <OrganizersGiveawayDetailPage /> },
      { path: 'terms-and-conditions', element: <TermsAndConditionsPage /> },
      { path: 'contact-us', element: <ContactUsPage /> },
      { path: 'clients', element: <ClientsPage /> },
      { path: 'clients/profile', element: <ClientsProfilePage /> },
      { path: 'faqs', element: <FAQSSPage /> },
      { path: 'users', element: <UserssPage /> },
      { path: 'categories', element: <CategoryPage /> },
      { path: 'users/profile', element: <UserssProfilePage /> },
      // { path: 'giveaway/detail', element: <GiveawayDetailPage /> },
      { path: 'organizers', element: <OrganizersPage /> },
      { path: 'organizers/profile', element: <OrganizersProfilePage /> },
      { path: 'privacy-policy', element: <PrivacyPolicysPage /> },
    ],
  },
];
